import __request__ from "routing/request";
export function renderHtml(type, JSONbody, requestOptions) {
  return __request__("POST", `/system/notification/message/html/${type}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderHtmlWithKey(type, key, JSONbody, requestOptions) {
  return __request__("POST", `/system/notification/message/html/${type}/${key}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderPlainText(type, JSONbody, requestOptions) {
  return __request__("POST", `/system/notification/message/plaintext/${type}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderPlainTextWithKey(type, key, JSONbody, requestOptions) {
  return __request__("POST", `/system/notification/message/plaintext/${type}/${key}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
